import * as React from "react"
import * as styles from '../styles/modal_section.module.css'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

export function ModalSection({ onClose }) {

    return (
        <button className={styles.section_modal} onClick={onClose}>
            <div className={styles.youtube_wrapper}>
                <CloseOutlinedIcon style={{ color: 'white', height: '56px', width: '56px', cursor: 'pointer' }} onClick={onClose} />
                <iframe className={styles.youtube_image}
                    src="https://www.youtube.com/embed/5nrvsT8YCAs?si=5CSE971EIiwvH9WK" 
                    title="YouTube video player" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen>
                </iframe>
            </div>
            <div className={styles.non_scroll}></div>
        </button>
    )
  }